<form
  [formGroup]="formGroup"
  class="dynamic-form"
  [class.scroll-cols]="scrollableColumns"
>
  @for (row of groupRows; track row) {
    <div class="row">
      @for (col of groupCols; track col) {
        <div class="col">
          @for (group of propertyGroups; track group) {
            @if (
              group.hasVisibleItems &&
                group["row"] == row &&
                group["col"] == col && { count: 0 };
              as filteredCount
            ) {
              <div [ngClass]="group.style ?? null">
                @if (
                  (group["properties"]
                    | countGroupMatches
                      : fieldFilterString
                      : isFilterEnabled) !== 0
                ) {
                  <div class="form-group-panel">
                    @if (group.key && group.key !== defaultGroup.key) {
                      <h4>
                        {{ group.key | translate }}
                      </h4>
                    }
                    <div class="row">
                      @for (column of group["properties"]; track column) {
                        <div class="col">
                          @for (
                            lineProperties of column;
                            track lineProperties
                          ) {
                            <div
                              class="line-properties"
                              [class.inline-controls]="
                                lineProperties.length > 1
                              "
                            >
                              @for (
                                prop of lineProperties
                                  | filterByPropertyLabel
                                    : fieldFilterString
                                    : isFilterEnabled
                                  | countFiltered: filteredCount;
                                track prop
                              ) {
                                <div class="property-editor">
                                  @if (
                                    prop.shouldDisplaySubject == undefined ||
                                    (prop.shouldDisplaySubject | async)
                                  ) {
                                    <div
                                      class="property-box"
                                      [ngStyle]="
                                        $safeNavigationMigration(
                                          prop?.additionalConfig?.[
                                            'containerStyleProperties'
                                          ]
                                        )
                                      "
                                      [hidden]="
                                        prop.tabIndex !== undefined &&
                                        tabState[prop.tabIndex] &&
                                        prop.tabName != tabState[prop.tabIndex]
                                      "
                                    >
                                      <!-- Text Input -->
                                      @if (prop.controlType === "text") {
                                        <sui-form-field class="w-100">
                                          @if (prop.propertyLabel) {
                                            <label
                                              sui-label
                                              [innerHTML]="
                                                prop.propertyLabel
                                                  | highlight: fieldFilterString
                                              "
                                            ></label>
                                          }
                                          <!-- Check if propertyNameLanguages is defined -->
                                          @if (prop.propertyNameLanguages) {
                                            @for (
                                              lang of getLanguageKeys(
                                                prop.propertyNameLanguages
                                              );
                                              track lang
                                            ) {
                                              @if (
                                                lang ==
                                                currentLanguageId.toString()
                                              ) {
                                                <div>
                                                  <sui-input
                                                    [formControlName]="
                                                      prop
                                                        .propertyNameLanguages[
                                                        lang
                                                      ]
                                                    "
                                                    [id]="
                                                      prop
                                                        .propertyNameLanguages[
                                                        lang
                                                      ]
                                                    "
                                                    [placeholder]="
                                                      prop.additionalConfig
                                                        ?.placeholder ?? ''
                                                    "
                                                    [readonly]="
                                                      prop.additionalConfig?.[
                                                        'disabled'
                                                      ] || false
                                                    "
                                                  ></sui-input>
                                                  @if (prop.metricSymbol) {
                                                    <span class="unit-label">{{
                                                      prop.metricSymbol
                                                    }}</span>
                                                  }
                                                </div>
                                              }
                                            }
                                          } @else {
                                            <div class="input-container">
                                              <sui-input
                                                [formControlName]="
                                                  prop.propertyName
                                                "
                                                [id]="prop.propertyName"
                                                [placeholder]="
                                                  prop.additionalConfig
                                                    ?.placeholder ?? ''
                                                "
                                              ></sui-input>
                                              @if (prop.metricSymbol) {
                                                <span class="unit-label">{{
                                                  prop.metricSymbol
                                                }}</span>
                                              }
                                            </div>
                                          }
                                          <!-- Fallback single control -->
                                        </sui-form-field>
                                      }
                                      <!-- File Input -->
                                      @if (prop.controlType === "file-input") {
                                        <sui-form-field class="w-100">
                                          @if (prop.propertyLabel) {
                                            <label
                                              sui-label
                                              [innerHTML]="
                                                prop.propertyLabel
                                                  | highlight: fieldFilterString
                                              "
                                            ></label>
                                          }
                                          <!-- Check if propertyNameLanguages is defined -->
                                          @if (prop.propertyNameLanguages) {
                                            @for (
                                              lang of getLanguageKeys(
                                                prop.propertyNameLanguages
                                              );
                                              track lang
                                            ) {
                                              @if (
                                                lang ==
                                                currentLanguageId.toString()
                                              ) {
                                                <sui-file-input
                                                  [formControlName]="
                                                    prop.propertyNameLanguages[
                                                      lang
                                                    ]
                                                  "
                                                  [id]="
                                                    prop.propertyNameLanguages[
                                                      lang
                                                    ]
                                                  "
                                                  [accept]="
                                                    prop.additionalConfig
                                                      ?.types ?? ''
                                                  "
                                                ></sui-file-input>
                                              }
                                            }
                                          } @else {
                                            <sui-file-input
                                              [formControlName]="
                                                prop.propertyName
                                              "
                                              [id]="prop.propertyName"
                                              [accept]="
                                                prop.additionalConfig?.types ??
                                                ''
                                              "
                                            ></sui-file-input>
                                          }
                                          <!-- Fallback single control -->
                                        </sui-form-field>
                                      }
                                      <!-- Search -->
                                      @if (prop.controlType === "search") {
                                        <app-search-input
                                          [placeholder]="
                                            prop.additionalConfig
                                              ?.placeholder ?? ''
                                          "
                                          [formControlName]="prop.propertyName"
                                          [id]="prop.propertyName"
                                        >
                                        </app-search-input>
                                      }
                                      <!-- Password Input -->
                                      @if (prop.controlType === "password") {
                                        <sui-form-field class="w-100">
                                          <label
                                            sui-label
                                            [innerHTML]="
                                              prop.propertyLabel
                                                | highlight: fieldFilterString
                                            "
                                          ></label>
                                          <div class="input-container">
                                            <sui-input
                                              [type]="
                                                passwordRevealed()[
                                                  prop.propertyName
                                                ]
                                                  ? 'text'
                                                  : 'password'
                                              "
                                              [formControlName]="
                                                prop.propertyName
                                              "
                                              [id]="prop.propertyName"
                                              [placeholder]="
                                                prop.additionalConfig
                                                  ?.placeholder ?? ''
                                              "
                                            >
                                              <!-- Reveal / copy affixes: only the variants that set the flags (proxy credentials, WAP-1777). -->
                                              @if (
                                                prop.additionalConfig
                                                  ?.revealable ||
                                                prop.additionalConfig?.copyable
                                              ) {
                                                <span
                                                  sui-suffix
                                                  class="password-actions"
                                                >
                                                  @if (
                                                    prop.additionalConfig
                                                      ?.revealable
                                                  ) {
                                                    <fa-icon
                                                      class="password-action"
                                                      [icon]="
                                                        passwordRevealed()[
                                                          prop.propertyName
                                                        ]
                                                          ? ['far', 'eye-slash']
                                                          : ['far', 'eye']
                                                      "
                                                      [title]="
                                                        (passwordRevealed()[
                                                          prop.propertyName
                                                        ]
                                                          ? 'btn.hide'
                                                          : 'btn.show'
                                                        ) | translate
                                                      "
                                                      (click)="
                                                        togglePasswordReveal(
                                                          prop.propertyName
                                                        )
                                                      "
                                                    ></fa-icon>
                                                  }
                                                  @if (
                                                    prop.additionalConfig
                                                      ?.copyable
                                                  ) {
                                                    <fa-icon
                                                      class="password-action"
                                                      [icon]="['fas', 'copy']"
                                                      [title]="
                                                        'btn.copy' | translate
                                                      "
                                                      (click)="
                                                        copyFieldValue(
                                                          prop.propertyName
                                                        )
                                                      "
                                                    ></fa-icon>
                                                  }
                                                </span>
                                              }
                                            </sui-input>
                                            @if (
                                              prop.additionalConfig?.strength &&
                                              getPassword(prop.propertyName)
                                            ) {
                                              <app-password-strength
                                                [passwordToCheck]="
                                                  getPassword(prop.propertyName)
                                                "
                                              ></app-password-strength>
                                            }
                                            @if (prop.metricSymbol) {
                                              <span class="unit-label">{{
                                                prop.metricSymbol
                                              }}</span>
                                            }
                                          </div>
                                        </sui-form-field>
                                      }
                                      <!-- Number Input-->
                                      @if (
                                        prop.controlType === "input-number"
                                      ) {
                                        <sui-form-field>
                                          <label
                                            sui-label
                                            [innerHTML]="
                                              prop.propertyLabel
                                                | highlight: fieldFilterString
                                            "
                                          >
                                          </label>
                                          <sui-input
                                            type="number"
                                            [formControlName]="
                                              prop.propertyName
                                            "
                                            [id]="prop.propertyName"
                                            [placeholder]="
                                              prop.additionalConfig
                                                ?.placeholder ?? ''
                                            "
                                            [min]="
                                              prop.additionalConfig?.['min'] ||
                                              0
                                            "
                                            [max]="
                                              $safeNavigationMigration(
                                                prop.additionalConfig?.['max']
                                              )
                                            "
                                            [readonly]="
                                              prop.additionalConfig?.[
                                                'disabled'
                                              ] || false
                                            "
                                          >
                                            @if (prop.metricSymbol) {
                                              <span sui-suffix>{{
                                                prop.metricSymbol
                                              }}</span>
                                            }
                                          </sui-input>
                                        </sui-form-field>
                                      }
                                      <!-- Text Area -->
                                      @if (prop.controlType === "textarea") {
                                        <sui-form-field>
                                          @if (prop.propertyLabel) {
                                            <label
                                              sui-label
                                              [innerHTML]="
                                                prop.propertyLabel
                                                  | highlight: fieldFilterString
                                              "
                                            ></label>
                                          }
                                          <!-- Check if propertyNameLanguages is defined -->
                                          @if (prop.propertyNameLanguages) {
                                            @for (
                                              lang of getLanguageKeys(
                                                prop.propertyNameLanguages
                                              );
                                              track lang
                                            ) {
                                              @if (
                                                lang ==
                                                currentLanguageId.toString()
                                              ) {
                                                <div>
                                                  <sui-textarea
                                                    [placeholder]="
                                                      prop.additionalConfig
                                                        ?.placeholder ?? ''
                                                    "
                                                    [formControlName]="
                                                      prop
                                                        .propertyNameLanguages[
                                                        lang
                                                      ]
                                                    "
                                                    [id]="
                                                      prop
                                                        .propertyNameLanguages[
                                                        lang
                                                      ]
                                                    "
                                                    [readonly]="
                                                      prop.additionalConfig?.[
                                                        'disabled'
                                                      ] || false
                                                    "
                                                    [rows]="
                                                      prop.additionalConfig
                                                        ? prop.additionalConfig[
                                                            'rows'
                                                          ]
                                                        : 4
                                                    "
                                                  ></sui-textarea>
                                                </div>
                                              }
                                            }
                                          } @else {
                                            <sui-textarea
                                              [formControlName]="
                                                prop.propertyName
                                              "
                                              [placeholder]="
                                                prop.additionalConfig
                                                  ?.placeholder ?? ''
                                              "
                                              [rows]="
                                                prop.additionalConfig
                                                  ? prop.additionalConfig[
                                                      'rows'
                                                    ]
                                                  : 4
                                              "
                                            ></sui-textarea>
                                          }
                                          <!-- Fallback single textarea -->
                                        </sui-form-field>
                                      }
                                      <!-- chat message -->
                                      @if (
                                        prop.controlType === "chat-message"
                                      ) {
                                        <div class="form-control-group">
                                          @if (prop.propertyLabel) {
                                            <label
                                              [for]="prop.propertyName"
                                              class="form-label"
                                              [innerHTML]="
                                                prop.propertyLabel
                                                  | highlight: fieldFilterString
                                              "
                                            ></label>
                                          }
                                          <app-chat-message-input
                                            [formGroup]="formGroup"
                                            [formControlName]="
                                              prop.propertyName
                                            "
                                          >
                                          </app-chat-message-input>
                                          <!-- Check if propertyNameLanguages is defined -->
                                        </div>
                                      }
                                      <!-- end chat message-->
                                      <!-- Toggle / Checkbox -->
                                      @if (prop.controlType === "toggle") {
                                        <div class="form-control-group">
                                          <!-- nullable (mass-update) → 3-position sui-toggle;
                                              everything else → binary sui-switch. -->
                                          @if (
                                            (prop.additionalConfig
                                              ?.tripleStateMode ?? "none") ===
                                            "nullable"
                                          ) {
                                            <sui-toggle
                                              variant="nullable"
                                              [formControlName]="
                                                prop.propertyName
                                              "
                                              [label]="prop.propertyLabel"
                                            ></sui-toggle>
                                          } @else {
                                            <sui-switch
                                              [formControlName]="
                                                prop.propertyName
                                              "
                                            >
                                              <span
                                                [innerHTML]="prop.propertyLabel"
                                              ></span>
                                            </sui-switch>
                                          }
                                        </div>
                                      }
                                      <!-- Select List -->
                                      @if (prop.controlType === "select") {
                                        <sui-form-field class="w-100">
                                          <label
                                            sui-label
                                            [innerHTML]="
                                              prop.propertyLabel
                                                | highlight: fieldFilterString
                                            "
                                          ></label>
                                          <div class="select-container">
                                            @if (
                                              prop.valueOptions ||
                                              prop.valueOptionsAsync
                                            ) {
                                              <!-- groupBy (e.g. export-settings) → carried onto the
                                                  options via comboboxOptions; sui-combobox renders
                                                  grouped headers when present, flat otherwise. -->
                                              <sui-combobox
                                                class="select"
                                                [id]="prop.propertyName"
                                                [options]="
                                                  prop.valueOptions ||
                                                    (prop.valueOptionsAsync
                                                      | async)
                                                    | comboboxOptions
                                                      : $safeNavigationMigration(
                                                          prop.additionalConfig
                                                            ?.groupBy
                                                        )
                                                "
                                                [formControlName]="
                                                  prop.propertyName
                                                "
                                                [clearable]="
                                                  isSelectClearable(prop)
                                                "
                                                [loading]="prop.loading"
                                                [placeholder]="
                                                  prop.additionalConfig
                                                    ?.placeholder ??
                                                  ('select.default-label.select-an-option'
                                                    | translate)
                                                "
                                              ></sui-combobox>
                                            }
                                            @if (
                                              prop.additionalConfig &&
                                              prop.additionalConfig[
                                                "buttons"
                                              ] &&
                                              prop.additionalConfig["buttons"]
                                                .length > 0
                                            ) {
                                              @for (
                                                button of prop.additionalConfig[
                                                  "buttons"
                                                ];
                                                track button
                                              ) {
                                                @if (button.visible) {
                                                  <sui-button
                                                    [variant]="
                                                      button.variant ||
                                                      'secondary'
                                                    "
                                                    [leadingIcon]="
                                                      button.leadingIcon
                                                    "
                                                    [iconOnly]="!button.label"
                                                    [ariaLabel]="
                                                      !button.label
                                                        ? $safeNavigationMigration(
                                                            button?.tooltip
                                                          )
                                                        : undefined
                                                    "
                                                    [suiTooltip]="
                                                      $safeNavigationMigration(
                                                        button?.tooltip
                                                      )
                                                    "
                                                    (click)="
                                                      onSelectButtonClick(
                                                        prop,
                                                        button
                                                      )
                                                    "
                                                  >
                                                    {{ button.label }}
                                                  </sui-button>
                                                }
                                              }
                                            }
                                          </div>
                                        </sui-form-field>
                                      }
                                      <!-- Multi-select (incl. autocomplete nomenclature pickers) -->
                                      @if (
                                        prop.controlType === "multiselect" ||
                                        prop.controlType === "autocomplete"
                                      ) {
                                        <sui-form-field class="w-100">
                                          <label
                                            sui-label
                                            [innerHTML]="
                                              prop.propertyLabel
                                                | highlight: fieldFilterString
                                            "
                                          ></label>
                                          <div class="select-container">
                                            <sui-combobox
                                              class="select"
                                              [id]="prop.propertyName"
                                              [multiple]="true"
                                              [options]="
                                                prop.valueOptions ||
                                                  (prop.valueOptionsAsync
                                                    | async) | comboboxOptions
                                              "
                                              [formControlName]="
                                                prop.propertyName
                                              "
                                              [loading]="prop.loading"
                                              [placeholder]="''"
                                            ></sui-combobox>
                                          </div>
                                        </sui-form-field>
                                      }
                                      <!-- renderer branch -->
                                      @if (
                                        prop.controlType === "colorpicker-array"
                                      ) {
                                        <div class="form-control-group">
                                          @for (
                                            i of range(getArrayLen(prop));
                                            track i;
                                            let idx = $index
                                          ) {
                                            <div class="color-picker-container">
                                              <app-color-picker
                                                [formControlName]="
                                                  prop.propertyName + '.' + i
                                                "
                                              ></app-color-picker>
                                              <label class="form-label">
                                                {{
                                                  (prop.propertyLabel ||
                                                    "Color") +
                                                    " " +
                                                    (i + 1)
                                                }}
                                              </label>
                                            </div>
                                          }
                                        </div>
                                      }
                                      <!-- Color Picker-->
                                      @if (prop.controlType === "colorpicker") {
                                        <div class="form-control-group">
                                          <div class="color-picker-container">
                                            <app-color-picker
                                              [formControlName]="
                                                prop.propertyName
                                              "
                                            ></app-color-picker>
                                            <label
                                              [for]="prop.propertyName"
                                              class="form-label"
                                              [innerHTML]="
                                                prop.propertyLabel
                                                  | highlight: fieldFilterString
                                              "
                                            ></label>
                                          </div>
                                        </div>
                                      }
                                      <!-- Language Picker  -->
                                      @if (
                                        prop.controlType === "language-picker"
                                      ) {
                                        <div class="form-control-group">
                                          <app-language-pills
                                            [hasDefault]="
                                              prop.additionalConfig?.[
                                                'hasDefault'
                                              ] ?? true
                                            "
                                            (onLanguageChanged)="
                                              onLanguageChanged($event)
                                            "
                                          ></app-language-pills>
                                        </div>
                                      }
                                      <!-- DataSource Picker -->
                                      @if (prop.controlType === "ds-picker") {
                                        <div>
                                          <app-datasource-selector
                                            [formGroup]="formGroup"
                                            [formGroupProperty]="
                                              prop?.additionalConfig?.[
                                                'formGroupProperty'
                                              ] || 'defaultFormGroupProperty'
                                            "
                                            [formGroupClassIdProperty]="
                                              prop?.additionalConfig?.[
                                                'formGroupClassIdProperty'
                                              ] || ''
                                            "
                                            [formGroupColorProperty]="
                                              prop?.additionalConfig?.[
                                                'formGroupColorProperty'
                                              ] || ''
                                            "
                                            [objectTypeIds]="
                                              prop?.additionalConfig?.[
                                                'objectTypeIds'
                                              ] || []
                                            "
                                            [widget]="
                                              $safeNavigationMigration(
                                                prop?.additionalConfig?.[
                                                  'widget'
                                                ]
                                              )
                                            "
                                          ></app-datasource-selector>
                                        </div>
                                      }
                                      <!-- tabs -->
                                      @if (prop.controlType === "tabs") {
                                        <div>
                                          <app-form-tabs
                                            [formTab]="
                                              prop.additionalConfig['formTab']
                                            "
                                            [counters]="
                                              prop?.additionalConfig?.[
                                                'counters'
                                              ]
                                                ? $safeNavigationMigration(
                                                    prop?.additionalConfig?.[
                                                      'counters'
                                                    ]
                                                  )
                                                : null
                                            "
                                            (onTabChanged)="
                                              onTabChanged($event)
                                            "
                                          ></app-form-tabs>
                                        </div>
                                      }
                                      <!-- checkbox array -->
                                      @if (
                                        $safeNavigationMigration(
                                          prop?.additionalConfig?.[
                                            "loadingAsync"
                                          ]
                                        ) | async
                                      ) {
                                        <app-loading></app-loading>
                                      }
                                      <!-- ! Summary Widget type -->
                                      @if (
                                        prop.controlType ===
                                          "structured-checkbox-array" &&
                                        !(
                                          $safeNavigationMigration(
                                            prop?.additionalConfig?.[
                                              "loadingAsync"
                                            ]
                                          ) | async
                                        )
                                      ) {
                                        <div
                                          class="checkbox-array"
                                          [id]="prop.propertyName"
                                          [style.overflow-y]="
                                            prop?.additionalConfig?.[
                                              'overflowY'
                                            ]
                                          "
                                          [style.max-height]="
                                            prop?.additionalConfig?.maxHeight
                                          "
                                        >
                                          @if (prop.propertyLabel) {
                                            <label
                                              sui-label
                                              [innerHTML]="
                                                prop.propertyLabel
                                                  | highlight: fieldFilterString
                                              "
                                            ></label>
                                          }
                                          @if (
                                            {
                                              options: prop.additionalConfig
                                                ?.valuesAsync
                                                ? (prop.additionalConfig[
                                                    "valuesAsync"
                                                  ](formGroup) | async)
                                                : prop.additionalConfig?.values,
                                            };
                                            as resolved
                                          ) {
                                            @if (resolved.options; as options) {
                                              <div
                                                cdkDropList
                                                class="structured-checkbox-array-list"
                                                (cdkDropListDropped)="
                                                  onStructuredCheckArrayDrop(
                                                    $event,
                                                    prop.propertyName,
                                                    options
                                                  )
                                                "
                                              >
                                                @for (
                                                  choice of getSortedStructuredOptions(
                                                    prop.propertyName,
                                                    options
                                                  )
                                                    | customFilterOptions
                                                      : formGroup
                                                      : $safeNavigationMigration(
                                                          prop.additionalConfig
                                                            ?.filterFn
                                                        );
                                                  track choice
                                                ) {
                                                  <div
                                                    cdkDrag
                                                    class="checkbox structured-checkbox-array-item"
                                                  >
                                                    <div
                                                      class="drag-handle"
                                                      cdkDragHandle
                                                    >
                                                      <fa-icon
                                                        [icon]="[
                                                          'fas',
                                                          'grip-vertical',
                                                        ]"
                                                      ></fa-icon>
                                                    </div>
                                                    <sui-checkbox
                                                      [checked]="
                                                        isStructuredMetricChecked(
                                                          prop.propertyName,
                                                          choice.value
                                                        )
                                                      "
                                                      (checkedChange)="
                                                        onStructuredCheckArrayChange(
                                                          $event,
                                                          prop.propertyName,
                                                          choice.value,
                                                          options
                                                        )
                                                      "
                                                    >
                                                      <span>
                                                        @if (choice.icon) {
                                                          <span
                                                            ><fa-icon
                                                              [icon]="
                                                                choice.icon
                                                              "
                                                            ></fa-icon
                                                          ></span>
                                                        }
                                                        <span>
                                                          {{
                                                            choice.name
                                                          }}</span
                                                        >
                                                      </span>
                                                    </sui-checkbox>
                                                  </div>
                                                }
                                              </div>
                                            }
                                          }
                                        </div>
                                      }
                                      <!-- ! HTML Widget type (Top Influencer) -->
                                      @if (
                                        prop.controlType === "checkbox-array" &&
                                        !(
                                          $safeNavigationMigration(
                                            prop?.additionalConfig?.[
                                              "loadingAsync"
                                            ]
                                          ) | async
                                        )
                                      ) {
                                        <div
                                          class="checkbox-array"
                                          [id]="prop.propertyName"
                                          [style.overflow-y]="
                                            prop?.additionalConfig?.[
                                              'overflowY'
                                            ]
                                          "
                                          [style.max-height]="
                                            prop?.additionalConfig?.maxHeight
                                          "
                                        >
                                          @if (prop.propertyLabel) {
                                            <label
                                              sui-label
                                              [innerHTML]="
                                                prop.propertyLabel
                                                  | highlight: fieldFilterString
                                              "
                                            ></label>
                                          }
                                          @if (
                                            {
                                              options: prop.additionalConfig
                                                ?.valuesAsync
                                                ? (prop.additionalConfig[
                                                    "valuesAsync"
                                                  ](formGroup) | async)
                                                : prop.additionalConfig?.values,
                                            };
                                            as resolved
                                          ) {
                                            @if (resolved.options; as options) {
                                              @if (
                                                prop?.additionalConfig[
                                                  "showSelectedCount"
                                                ]
                                              ) {
                                                <div class="selected-count">
                                                  {{
                                                    "dynamic-form.label.selected"
                                                      | translate
                                                  }}
                                                  <span class="bold">{{
                                                    formGroup.get([
                                                      prop.propertyName,
                                                    ])?.value?.length || 0
                                                  }}</span>
                                                  {{
                                                    "dynamic-form.label.feeds-or-dashboards"
                                                      | translate
                                                  }}
                                                </div>
                                              }
                                              @if (
                                                prop.additionalConfig["groupBy"]
                                              ) {
                                                <div>
                                                  @for (
                                                    group of options
                                                      | customFilterOptions
                                                        : formGroup
                                                        : $safeNavigationMigration(
                                                            prop
                                                              .additionalConfig
                                                              ?.filterFn
                                                          )
                                                      | groupBy
                                                        : prop.additionalConfig[
                                                            "groupBy"
                                                          ];
                                                    track group
                                                  ) {
                                                    <div
                                                      class="checkbox-group-wrapper"
                                                    >
                                                      <div
                                                        class="group-header"
                                                        style="
                                                          margin-top: 10px;
                                                          font-weight: bold;
                                                        "
                                                      >
                                                        @if (
                                                          prop.additionalConfig[
                                                            "enableSelectAllPerGroup"
                                                          ]
                                                        ) {
                                                          <sui-checkbox
                                                            [checked]="
                                                              isGroupAllSelected(
                                                                prop.propertyName,
                                                                group.items
                                                              )
                                                            "
                                                            (checkedChange)="
                                                              checkGroupAll(
                                                                $event,
                                                                prop.propertyName,
                                                                group.items
                                                              )
                                                            "
                                                          >
                                                            <span
                                                              >{{
                                                                group.key
                                                              }}
                                                              ({{
                                                                "dynamic-form.label.select-all"
                                                                  | translate
                                                              }})</span
                                                            >
                                                          </sui-checkbox>
                                                        }
                                                        @if (
                                                          !prop
                                                            .additionalConfig[
                                                            "enableSelectAllPerGroup"
                                                          ]
                                                        ) {
                                                          <span>{{
                                                            group.key
                                                          }}</span>
                                                        }
                                                      </div>
                                                      @for (
                                                        choice of group.items;
                                                        track choice
                                                      ) {
                                                        <div
                                                          style="
                                                            margin-left: 20px;
                                                          "
                                                        >
                                                          <sui-checkbox
                                                            [checked]="
                                                              formGroup
                                                                .get([
                                                                  prop.propertyName,
                                                                ])
                                                                .value.includes(
                                                                  choice.value
                                                                )
                                                            "
                                                            (checkedChange)="
                                                              onCheckArrayChange(
                                                                $event,
                                                                prop.propertyName,
                                                                choice.value
                                                              )
                                                            "
                                                          >
                                                            <span>
                                                              @if (
                                                                choice.icon
                                                              ) {
                                                                <span
                                                                  ><fa-icon
                                                                    [icon]="
                                                                      choice.icon
                                                                    "
                                                                  ></fa-icon
                                                                ></span>
                                                              }
                                                              <span>
                                                                {{
                                                                  choice.name
                                                                }}</span
                                                              >
                                                            </span>
                                                          </sui-checkbox>
                                                        </div>
                                                      }
                                                    </div>
                                                  }
                                                </div>
                                              }
                                              @if (
                                                !prop.additionalConfig[
                                                  "groupBy"
                                                ]
                                              ) {
                                                <div>
                                                  @if (
                                                    prop.additionalConfig[
                                                      "enableSelectAll"
                                                    ]
                                                  ) {
                                                    <div>
                                                      <sui-checkbox
                                                        class="select-all-label"
                                                        [checked]="
                                                          checkAllSelected
                                                        "
                                                        (checkedChange)="
                                                          checkAll(
                                                            $event,
                                                            prop.propertyName,
                                                            options
                                                          )
                                                        "
                                                      >
                                                        <span>{{
                                                          "dynamic-form.label.select-all"
                                                            | translate
                                                        }}</span>
                                                      </sui-checkbox>
                                                    </div>
                                                  }
                                                  @for (
                                                    choice of options
                                                      | customFilterOptions
                                                        : formGroup
                                                        : $safeNavigationMigration(
                                                            prop
                                                              .additionalConfig
                                                              ?.filterFn
                                                          );
                                                    track choice
                                                  ) {
                                                    <div>
                                                      <sui-checkbox
                                                        [checked]="
                                                          formGroup
                                                            ?.get([
                                                              prop.propertyName,
                                                            ])
                                                            .value.includes(
                                                              choice.value
                                                            )
                                                        "
                                                        (checkedChange)="
                                                          onCheckArrayChange(
                                                            $event,
                                                            prop.propertyName,
                                                            choice.value
                                                          )
                                                        "
                                                      >
                                                        <span>
                                                          @if (choice.icon) {
                                                            <span
                                                              ><fa-icon
                                                                [icon]="
                                                                  choice.icon
                                                                "
                                                              ></fa-icon
                                                            ></span>
                                                          }
                                                          <span>
                                                            {{
                                                              choice.name
                                                            }}</span
                                                          >
                                                        </span>
                                                      </sui-checkbox>
                                                    </div>
                                                  }
                                                </div>
                                              }
                                            }
                                          }
                                        </div>
                                      }
                                      <!-- checkbox value -->
                                      @if (prop.controlType === "checkbox") {
                                        <sui-form-field>
                                          @if (
                                            prop.additionalConfig?.["label"]
                                          ) {
                                            <label
                                              sui-label
                                              [innerHTML]="
                                                $safeNavigationMigration(
                                                  prop.additionalConfig?.[
                                                    'label'
                                                  ]
                                                ) | highlight: fieldFilterString
                                              "
                                            ></label>
                                          }
                                          <sui-checkbox
                                            [formControlName]="
                                              prop.propertyName
                                            "
                                            (checkedChange)="
                                              onControlChange(prop, $event)
                                            "
                                          >
                                            <span
                                              [innerHTML]="
                                                prop.propertyLabel
                                                  | highlight: fieldFilterString
                                              "
                                            ></span>
                                          </sui-checkbox>
                                        </sui-form-field>
                                      }
                                      <!-- dataobject picker -->
                                      @if (
                                        prop.controlType === "dataobject-picker"
                                      ) {
                                        <div>
                                          <label
                                            class="form-label"
                                            [innerHTML]="
                                              prop.propertyLabel
                                                | highlight: fieldFilterString
                                            "
                                          ></label>
                                          @if (
                                            prop?.additionalConfig
                                              ?.objectsToDisplay &&
                                            prop.additionalConfig
                                              .objectsToDisplay.length > 0
                                          ) {
                                            <div class="objects">
                                              @for (
                                                object of prop.additionalConfig
                                                  .objectsToDisplay;
                                                track object
                                              ) {
                                                <div class="object">
                                                  <div class="icon">
                                                    <fa-icon
                                                      [icon]="object.icon"
                                                    ></fa-icon>
                                                  </div>
                                                  <div class="title">
                                                    {{ object.title }}
                                                  </div>
                                                  <div class="description">
                                                    {{ object.description }}
                                                  </div>
                                                  @if (
                                                    prop.additionalConfig
                                                      ?.removeButton
                                                  ) {
                                                    <sui-button
                                                      variant="danger"
                                                      [leadingIcon]="[
                                                        'fas',
                                                        'circle-xmark',
                                                      ]"
                                                      [iconOnly]="true"
                                                      ariaLabel="Remove"
                                                      (click)="
                                                        prop.additionalConfig?.removeAction()
                                                      "
                                                    ></sui-button>
                                                  }
                                                </div>
                                              }
                                            </div>
                                          } @else {
                                            <div>
                                              {{
                                                "dynamic-form.message.there-are-no-selected-objects"
                                                  | translate
                                              }}
                                            </div>
                                          }
                                          <div class="actions">
                                            <sui-button
                                              [variant]="
                                                prop.additionalConfig
                                                  ?.variant ?? 'primary'
                                              "
                                              [leadingIcon]="
                                                prop.additionalConfig
                                                  ?.leadingIcon ?? [
                                                  'fas',
                                                  'plus',
                                                ]
                                              "
                                              [suiTooltip]="
                                                $safeNavigationMigration(
                                                  prop.additionalConfig?.tooltip
                                                )
                                              "
                                              (click)="
                                                dataObjectPicker(
                                                  prop,
                                                  $safeNavigationMigration(
                                                    prop.additionalConfig
                                                      ?.singleSelectionActive
                                                  )
                                                )
                                              "
                                            >
                                              {{
                                                prop.additionalConfig?.label ??
                                                  ("btn.add" | translate)
                                              }}
                                            </sui-button>
                                          </div>
                                        </div>
                                      }
                                      <!-- principal picker -->
                                      @if (
                                        prop.controlType === "principal-picker"
                                      ) {
                                        <div>
                                          <label
                                            class="form-label"
                                            [innerHTML]="
                                              prop.propertyLabel
                                                | highlight: fieldFilterString
                                            "
                                          ></label>
                                          @if (
                                            prop?.additionalConfig
                                              ?.principalsToDisplay &&
                                            prop.additionalConfig
                                              .principalsToDisplay.length > 0
                                          ) {
                                            <div class="principals">
                                              @for (
                                                principal of prop
                                                  .additionalConfig
                                                  .principalsToDisplay;
                                                track principal
                                              ) {
                                                <app-principal-card
                                                  [principal]="principal"
                                                ></app-principal-card>
                                              }
                                            </div>
                                          } @else {
                                            <div class="noPrincipals">
                                              {{
                                                prop.additionalConfig
                                                  .noPrincipalsText ?? ""
                                              }}
                                            </div>
                                          }
                                          <div class="actions">
                                            <sui-button
                                              [variant]="
                                                prop.additionalConfig
                                                  ?.variant ?? 'primary'
                                              "
                                              [leadingIcon]="
                                                prop.additionalConfig
                                                  ?.leadingIcon ?? [
                                                  'fas',
                                                  'plus',
                                                ]
                                              "
                                              (click)="principalPicker(prop)"
                                            >
                                              {{
                                                prop.additionalConfig?.label ??
                                                  ("btn.add" | translate)
                                              }}
                                            </sui-button>
                                          </div>
                                        </div>
                                      }
                                      <!-- doggle button group-->
                                      @if (
                                        prop.controlType ===
                                        "toggle-button-group"
                                      ) {
                                        <div>
                                          <app-form-toggle-buttons
                                            [formControlName]="
                                              prop.propertyName
                                            "
                                            [buttons]="
                                              prop.additionalConfig['buttons']
                                            "
                                            (onValueChanged)="
                                              onToggleButtonsChange(
                                                $event,
                                                prop
                                              )
                                            "
                                          ></app-form-toggle-buttons>
                                        </div>
                                      }
                                      <!-- date picker -->
                                      @if (prop.controlType === "date-picker") {
                                        <div>
                                          <label
                                            class="form-label"
                                            [innerHTML]="
                                              prop.propertyLabel
                                                | highlight: fieldFilterString
                                            "
                                          ></label>
                                          <div class="input-group date-picker">
                                            <sui-date-picker
                                              [formControlName]="
                                                prop.propertyName
                                              "
                                              [id]="prop.propertyName"
                                              [placeholder]="
                                                prop.additionalConfig
                                                  ?.placeholder ?? ''
                                              "
                                              [min]="
                                                $safeNavigationMigration(
                                                  prop.additionalConfig?.[
                                                    'minDate'
                                                  ]
                                                )
                                              "
                                              [max]="
                                                $safeNavigationMigration(
                                                  prop.additionalConfig?.[
                                                    'maxDate'
                                                  ]
                                                )
                                              "
                                            ></sui-date-picker>
                                          </div>
                                        </div>
                                      }
                                      <!-- time picker -->
                                      @if (prop.controlType === "time-picker") {
                                        <div>
                                          <label
                                            class="form-label"
                                            [innerHTML]="
                                              prop.propertyLabel
                                                | highlight: fieldFilterString
                                            "
                                          ></label>
                                          <div class="input-group">
                                            <sui-date-time-picker
                                              mode="time"
                                              [id]="prop.propertyName"
                                              [formControlName]="
                                                prop.propertyName
                                              "
                                            ></sui-date-time-picker>
                                          </div>
                                        </div>
                                      }
                                      <!-- date range picker -->
                                      @if (
                                        prop.controlType === "date-range-picker"
                                      ) {
                                        <div>
                                          <label
                                            class="form-label"
                                            [innerHTML]="
                                              prop.propertyLabel
                                                | highlight: fieldFilterString
                                            "
                                          ></label>
                                          <app-form-date-range-picker
                                            [formGroup]="formGroup"
                                            [startPropertyName]="
                                              $safeNavigationMigration(
                                                prop.propertyNames?.[0]
                                              )
                                            "
                                            [endPropertyName]="
                                              $safeNavigationMigration(
                                                prop.propertyNames?.[1]
                                              )
                                            "
                                            [presetBar]="
                                              prop.additionalConfig?.[
                                                'presetBar'
                                              ] !== false
                                            "
                                            [timeDetails]="
                                              prop.additionalConfig?.[
                                                'timeDetails'
                                              ] !== false
                                            "
                                          ></app-form-date-range-picker>
                                        </div>
                                      }
                                      <!-- tags input (async suggestions) -->
                                      @if (
                                        prop.controlType === "tag-input" &&
                                        prop.additionalConfig?.valueOptionsAsync
                                      ) {
                                        <sui-form-field class="w-100">
                                          <label
                                            sui-label
                                            [innerHTML]="
                                              prop.propertyLabel
                                                | highlight: fieldFilterString
                                            "
                                          ></label>
                                          <sui-tags
                                            [id]="prop.propertyName"
                                            [options]="
                                              prop.additionalConfig
                                                .valueOptionsAsync
                                                | async
                                                | tagsOptions
                                                  : prop.additionalConfig?.[
                                                      'displayBy'
                                                    ] || 'text'
                                                  : prop.additionalConfig?.[
                                                      'identifyBy'
                                                    ] || 'id'
                                            "
                                            [formControlName]="
                                              prop.propertyName
                                            "
                                            [disabled]="
                                              prop.additionalConfig?.[
                                                'disabled'
                                              ] || false
                                            "
                                            [placeholder]="
                                              prop.additionalConfig?.[
                                                'placeholder'
                                              ] || 'Add a tag'
                                            "
                                          ></sui-tags>
                                        </sui-form-field>
                                      }
                                      <!-- tags input fallback: static options or free entry (no async source) -->
                                      @if (
                                        prop.controlType === "tag-input" &&
                                        !prop.additionalConfig
                                          ?.valueOptionsAsync
                                      ) {
                                        <sui-form-field class="w-100">
                                          <label
                                            sui-label
                                            [innerHTML]="
                                              prop.propertyLabel
                                                | highlight: fieldFilterString
                                            "
                                          ></label>
                                          <sui-tags
                                            [id]="prop.propertyName"
                                            [options]="
                                              $safeNavigationMigration(
                                                prop.additionalConfig
                                                  ?.valueOptions
                                              )
                                                | tagsOptions
                                                  : prop.additionalConfig?.[
                                                      'displayBy'
                                                    ] || 'text'
                                                  : prop.additionalConfig?.[
                                                      'identifyBy'
                                                    ] || 'id'
                                            "
                                            [formControlName]="
                                              prop.propertyName
                                            "
                                            [disabled]="
                                              prop.additionalConfig?.[
                                                'disabled'
                                              ] || false
                                            "
                                            [placeholder]="
                                              prop.additionalConfig?.[
                                                'placeholder'
                                              ] ||
                                              ('forms.tags-input.add-tag-label'
                                                | translate)
                                            "
                                          ></sui-tags>
                                        </sui-form-field>
                                      }
                                      <!-- Image Upload -->
                                      @if (
                                        prop.controlType === "image-upload"
                                      ) {
                                        <div>
                                          <app-image-upload
                                            [formControlName]="
                                              prop.propertyName
                                            "
                                            [formGroup]="formGroup"
                                          >
                                          </app-image-upload>
                                        </div>
                                      }
                                      @if (prop.controlType === "button") {
                                        <div>
                                          <sui-button
                                            [variant]="
                                              prop.additionalConfig?.[
                                                'variant'
                                              ] || 'primary'
                                            "
                                            [leadingIcon]="
                                              $safeNavigationMigration(
                                                prop.additionalConfig?.[
                                                  'leadingIcon'
                                                ]
                                              )
                                            "
                                            [trailingIcon]="
                                              prop.additionalConfig?.[
                                                'isDropdown'
                                              ]
                                                ? ['fas', 'caret-down']
                                                : undefined
                                            "
                                            [size]="
                                              prop.additionalConfig?.['size'] ||
                                              'md'
                                            "
                                            [disabled]="
                                              prop.additionalConfig?.[
                                                'disabled'
                                              ] || false
                                            "
                                            [loading]="
                                              ($safeNavigationMigration(
                                                prop.additionalConfig?.[
                                                  'loadingAsync'
                                                ]
                                              ) | async) || false
                                            "
                                            (click)="onButtonClick(prop)"
                                          >
                                            {{ prop.propertyLabel || "Button" }}
                                          </sui-button>
                                        </div>
                                      }
                                      @if (
                                        prop.controlType === "progress-steps"
                                      ) {
                                        <div>
                                          <app-progress-steps
                                            [steps]="
                                              $safeNavigationMigration(
                                                prop.additionalConfig?.['steps']
                                              )
                                            "
                                            [formControlName]="
                                              prop.propertyName
                                            "
                                          ></app-progress-steps>
                                        </div>
                                      }
                                      @if (
                                        prop.controlType === "progress-bar"
                                      ) {
                                        <div>
                                          <app-progress-bar
                                            [formControlName]="
                                              prop.propertyName
                                            "
                                          ></app-progress-bar>
                                        </div>
                                      }
                                      @if (prop.controlType === "info-alert") {
                                        <div>
                                          <div
                                            class="alert"
                                            role="alert"
                                            [ngClass]="
                                              prop.additionalConfig?.[
                                                'class'
                                              ] || 'alert-primary'
                                            "
                                          >
                                            {{
                                              prop.additionalConfig?.[
                                                "message"
                                              ] || "Info Alert"
                                            }}
                                          </div>
                                        </div>
                                      }
                                      @if (
                                        prop.controlType === "color-palette"
                                      ) {
                                        <div>
                                          <label
                                            class="form-label"
                                            [innerHTML]="
                                              prop.propertyLabel
                                                | highlight: fieldFilterString
                                            "
                                          ></label>
                                          <app-color-palette
                                            [formControlName]="
                                              prop.propertyName
                                            "
                                          ></app-color-palette>
                                        </div>
                                      }
                                      @if (
                                        prop.controlType === "image-cropper"
                                      ) {
                                        <div>
                                          <label
                                            class="form-label"
                                            [innerHTML]="
                                              prop.propertyLabel
                                                | highlight: fieldFilterString
                                            "
                                          ></label>
                                          <app-image-cropper
                                            [formControlName]="
                                              prop.propertyName
                                            "
                                            [formGroup]="formGroup"
                                            [height]="
                                              prop?.additionalConfig?.height ??
                                              200
                                            "
                                            [width]="
                                              prop?.additionalConfig?.width ??
                                              200
                                            "
                                            [defaultImageUrl]="
                                              $safeNavigationMigration(
                                                prop.additionalConfig
                                                  ?.defaultImageUrl
                                              )
                                            "
                                          >
                                          </app-image-cropper>
                                        </div>
                                      }
                                      @if (prop.controlType === "file-upload") {
                                        <div>
                                          <label
                                            class="form-label"
                                            [innerHTML]="
                                              prop.propertyLabel
                                                | highlight: fieldFilterString
                                            "
                                          ></label>
                                          <app-file-upload
                                            [fileType]="
                                              $safeNavigationMigration(
                                                prop.additionalConfig?.fileType
                                              )
                                            "
                                            [formControlName]="
                                              prop.propertyName
                                            "
                                          ></app-file-upload>
                                        </div>
                                      }
                                      @if (prop.controlType === "slider") {
                                        <sui-form-field class="w-100">
                                          <label
                                            sui-label
                                            [innerHTML]="
                                              prop.propertyLabel
                                                | highlight: fieldFilterString
                                            "
                                          ></label>
                                          <sui-range-slider
                                            [id]="prop.propertyName"
                                            [formControlName]="
                                              prop.propertyName
                                            "
                                            [min]="
                                              prop.additionalConfig?.options
                                                ?.floor ?? 0
                                            "
                                            [max]="
                                              prop.additionalConfig?.options
                                                ?.ceil ?? 100
                                            "
                                            [step]="
                                              prop.additionalConfig?.options
                                                ?.step ?? 1
                                            "
                                          ></sui-range-slider>
                                        </sui-form-field>
                                      }
                                      @if (prop.controlType === "component") {
                                        <div style="width: 100%; height: 100%">
                                          <ng-container
                                            #dynamicComponentContainer
                                          >
                                          </ng-container>
                                        </div>
                                      }
                                      @if (formGroup; as fg) {
                                        <!-- Password mismatch -->
                                        @if (
                                          hasAnyError(
                                            prop,
                                            "passwordMismatch"
                                          ) && anyTouched(prop)
                                        ) {
                                          <span class="text-danger">
                                            Passwords do not match.
                                          </span>
                                        }
                                        <!-- Required -->
                                        @if (
                                          (hasAnyError(prop, "required") ||
                                            hasAnyError(
                                              prop,
                                              "requiredNonZero"
                                            )) &&
                                          anyTouched(prop)
                                        ) {
                                          <span class="text-danger">
                                            {{ prop.propertyLabel }} is
                                            required.
                                          </span>
                                        }
                                        <!-- Invalid date (ngbDate.invalid) -->
                                        @if (
                                          hasAnyNestedError(prop, [
                                            "ngbDate",
                                            "invalid",
                                          ]) && anyTouched(prop)
                                        ) {
                                          <span class="text-danger">
                                            Invalid date
                                          </span>
                                        }
                                        <!-- Generic invalid -->
                                        @if (
                                          anyInvalid(prop) &&
                                          !hasAnyError(prop, "required") &&
                                          !hasAnyError(
                                            prop,
                                            "requiredNonZero"
                                          ) &&
                                          !hasAnyError(
                                            prop,
                                            "passwordMismatch"
                                          ) &&
                                          !hasAnyNestedError(prop, [
                                            "ngbDate",
                                            "invalid",
                                          ]) &&
                                          anyTouched(prop)
                                        ) {
                                          <span class="text-danger">
                                            Invalid input
                                          </span>
                                        }
                                      }
                                    </div>
                                  }
                                </div>
                              }
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          }
        </div>
      }
    </div>
  }
</form>
